'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
import { externalLinkProps } from '@/shared/links';
export default function HeartHunterCard(t0) {
  const $ = _c(20);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data) {
    t1 = data?.image?.previewsrc && <div className="aspect-[391/341] relative flex items-end justify-center lg:rounded-t-[18px] rounded-t-[14px] bg-[linear-gradient(180deg,rgba(255,255,255,0)_55.92%,rgba(153,153,153,0.3)_100%)]"><Image src={data?.image?.previewsrc} alt={data?.image?.altText || data.title} width="340" height="412" className="absolute object-contain left-auto right-auto mx-auto bottom-0 w-auto 2xl:max-h-[calc(100%+70px)] xl:max-h-[calc(100%+50px)] max-h-[calc(100%+30px)] max-w-[100%] h-auto" /></div>;
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data?.title) {
    t2 = data?.title && <h2 className="text-[#323232] font-semibold 2xl:text-[32px] xl:text-2xl lg:text-xl sm:text-lg text-base leading-[1.15] tracking-[-0.01em]">{data?.title}</h2>;
    $[2] = data?.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data?.subTitle) {
    t3 = data?.subTitle && <p className="text-[#626262] xl:text-lg md:text-base text-[13px] leading-[1.5] xl:mt-2.25 lg:mt-1.5 mt-1">{data?.subTitle}</p>;
    $[4] = data?.subTitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="2xl:px-9.5 xl:px-8 lg:px-6 px-5 2xl:pb-11 lg:pb-9 pb-8 xl:pt-7.5 lg:pt-5.5 pt-3.75">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const CardContent = t5;
  if (data?.linkUrl) {
    const t6 = data?.linkUrl;
    const t7 = data?.linkUrl;
    let t8;
    if ($[12] !== t7) {
      t8 = externalLinkProps(t7);
      $[12] = t7;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== CardContent || $[15] !== t6 || $[16] !== t8) {
      t9 = <Link href={t6} {...t8} className={"block bg-white lg:rounded-[18px] rounded-[14px]\n        shadow-[-2px_2px_27px_rgba(0,0,0,0.06)]\n        2xl:w-[20.37vw] xl:w-[21.5vw] lg:w-[28.5vw] md:w-[40vw] w-[53vw]\n        hover:shadow-lg transition h-full"}>{CardContent}</Link>;
      $[14] = CardContent;
      $[15] = t6;
      $[16] = t8;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    return t9;
  }
  let t6;
  if ($[18] !== CardContent) {
    t6 = <div className={"bg-white lg:rounded-[18px] rounded-[14px]\n      shadow-[-2.7px_2.7px_27px_rgba(0,0,0,0.06)]\n      2xl:w-[20.37vw] xl:w-[21.5vw] lg:w-[28.5vw] md:w-[40vw] w-[53vw] h-full"}>{CardContent}</div>;
    $[18] = CardContent;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}